<template>
    <div>
        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                    <a-divider dashed orientation="left">Update Foto</a-divider>
                    <a-row>
                        <a-col :span="12">

                            <a-form-item label="Foto"
                            >
                                <a-upload
                                    :file-list="fileList"
                                    :remove="handleRemove"
                                    :before-upload="beforeUpload"
                                    @change="handleChange"
                                >
                                    <a-button>
                                        <a-icon type="upload" /> Select File
                                    </a-button>
                                </a-upload>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <a-form-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </a-form>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        user_info: {
            type: Object
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            fileList: [],
            item: {},
        };
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault(e);

            if(this.fileList.length < 1){
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Foto tidak boleh kosong."
                });
                return;
            }

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    var data = new FormData();

                    for (var k in formData) {
                        if (formData.hasOwnProperty(k)) {
                            data.append(k, formData[k] == undefined ? "" :formData[k]);
                        }
                    }

                    data.append("photo", this.fileList[0]);

                    promise = this.$http.post(
                        this.routeUri("api.setting.profile.update", {user_hash: this.user_info.hash}),
                        data
                    );

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
            this.data = [];
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file];
            return false;
        },
        handleChange(info) {
            let fileList = [...info.fileList];

            if (fileList.length > 1) {
                fileList = fileList.slice(-1);

                fileList = fileList.map(file => {
                    if (file.response) {
                        file.url = file.response.url;
                    }
                    return file;
                });
                this.fileList = fileList;
            }
        }
    }
}
</script>
